import React, { useState } from "react";
import Innova_v2 from "../assets/wallpapers/Innova_V2.jpg"; 

export default function Reviews() {
  const [reviews, setReviews] = useState([
    { name: "Amit Kumar", comment: "Excellent service! Driver was polite and on time." },
    { name: "Priya Singh", comment: "Clean car and comfortable ride. Will book again." },
  ]);

  const [formData, setFormData] = useState({ name: "", comment: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.name.trim() && formData.comment.trim()) {
      setReviews([...reviews, { name: formData.name, comment: formData.comment }]);
      setFormData({ name: "", comment: "" }); // reset form
    }
  };

  return (
    <div
      className="min-h-screen bg-cover bg-center p-8"
      style={{ backgroundImage: `url(${Innova_v2})` }}
    >
      <h2 className="text-4xl font-bold mb-6 text-white drop-shadow-lg">Customer Reviews</h2>

      {/* Transparent form */}
      <form
        onSubmit={handleSubmit}
        className="bg-white bg-opacity-30 backdrop-blur-md rounded-md p-6 max-w-md mx-auto mb-10 shadow-lg"
      >
        <h3 className="text-2xl font-semibold mb-4 text-gray-900">Leave Your Feedback</h3>

        <input
          type="text"
          name="name"
          placeholder="Your Name"
          value={formData.name}
          onChange={handleChange}
          className="w-full mb-4 p-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          required
        />

        <textarea
          name="comment"
          placeholder="Your Review"
          value={formData.comment}
          onChange={handleChange}
          className="w-full mb-4 p-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          rows={4}
          required
        />

        <button
          type="submit"
          className="bg-indigo-600 hover:bg-indigo-700 text-white font-semibold px-6 py-2 rounded transition"
        >
          Submit
        </button>
      </form>

      {/* Display reviews */}
      <div className="max-w-5xl mx-auto">
        {reviews.map((review, idx) => (
          <div key={idx} className="bg-white bg-opacity-80 shadow p-4 rounded-md mb-4">
            <h3 className="text-xl font-semibold">{review.name}</h3>
            <p className="text-gray-800">{review.comment}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
